import { SubscriptionToggleConfigurationInterface } from 'server/config-cache/types';

/**
 * Checks config.subscriptionToggleConfiguration, which is an enum with 4 options (Check out SubscriptionToggleConfigurationInterface too see type).
 *
 * Based on the enum type passed as a parameter, returns true or false depending on tenant config. (We also hide subscription toggle for 2 of the 4 configs :))
 */
export const getSubscriptionRecurringBooleanFromConfig = (
  subscriptionToggle: SubscriptionToggleConfigurationInterface | undefined,
): boolean => {
  if (
    subscriptionToggle === 'only-subscription' ||
    subscriptionToggle === 'both-subscription-on' ||
    subscriptionToggle === undefined
  ) {
    return true;
  }

  return false;
};
